import { UploadOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import { getImageUrlFromStorage } from 'library/helpers/getImageUrlFromStorage';
import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { Loader, Notification } from 'zComponents/atoms';
import { Flex, Typography } from 'zui/Antd';
import ProfilePicUpload from '../UploadImageFirebase';
import UploadBoxWrapper from './UploadBoxWrapper';

const { Text } = Typography;

const UploadBox = ({
	entityID,
	entityName,
	shape = 'square',
	cursor = true,
	edit = true,
	size,
	uploadType,
	uploadRef,
	setImage,
	image,
	setImagePath,
	imagePath,
	placeHolderUpload = 'Click to Upload'
}) => {
	const {
		token: { colorTextLabel, fontWeightStrong }
	} = theme.useToken();
	const [loading, setLoading] = useState(true);
	const [uploadLoading, setUploadLoading] = useState(false);

	useEffect(() => {
		let mounted = true;
		const fetchImage = async () => {
			setLoading(true);
			if (imagePath) {
				try {
					const url = await getImageUrlFromStorage(imagePath);
					if (mounted) setImage(url);
				} catch {
					if (mounted) setImage(null);
				}
			} else {
				if (mounted) setImage(null);
			}
			if (mounted) setLoading(false);
		};
		fetchImage();
		return () => {
			mounted = false;
		};
	}, [imagePath, setImage]);

	// When upload succeeds, receive the new file path
	const handleUploadSuccess = async (newFilePath) => {
		Notification('success', 'Upload successful!');
		setLoading(true);
		setImagePath(newFilePath);
	};

	const variant = edit && !image ? 'upload' : 'preview';

	const inner =
		variant === 'upload' ? (
			<Flex vertical align='center' justify='center' gap={5}>
				{uploadLoading ? <Loader /> : <UploadOutlined style={{ color: colorTextLabel, fontSize: 16 }} />}
				<Text style={{ color: colorTextLabel, fontWeight: fontWeightStrong }}>
					{uploadLoading ? 'Uploading...' : placeHolderUpload}
				</Text>
			</Flex>
		) : (
			<div className='contentContainer'>
				{edit && (
					<div className='editIconContainer'>
						<p className='editIconContent'>
							{image ? 'Update' : 'Upload'}
							<br />
							Picture
						</p>
					</div>
				)}
				{loading || uploadLoading ? (
					<Loader />
				) : image ? (
					<LazyLoadImage src={image} effect='blur' className='imageLazy' />
				) : (
					<Loader />
				)}
			</div>
		);

	const wrapped = (
		<UploadBoxWrapper shape={shape} cursor={cursor} variant={variant} size={size}>
			{inner}
		</UploadBoxWrapper>
	);

	if (edit) {
		return (
			<div className='upload-container upload-wrapper' style={{ width: '100%' }}>
				<ProfilePicUpload
					{...{
						entityID,
						entityName,
						uploadType,
						uploadRef,
						onUploadSuccess: handleUploadSuccess,
						setUploadLoading: setUploadLoading

						// oldData: {
						// 	mapID: mapID,
						// 	url: imagePath
						// }
					}}
				>
					{wrapped}
				</ProfilePicUpload>
			</div>
		);
	}
	return wrapped;
};

export default UploadBox;
